import { HStack, Text } from "@chakra-ui/react";
import { formatChordLabel, shortcutById } from "~/app/shortcuts";
import { Kbd } from "~/components/ui/kbd";

interface CommandBarFooterProps {
  isMac: boolean;
}

/** The palette's own keys, read from the shortcuts map (src/app/shortcuts.ts). */
const FOOTER_HINTS = [
  { id: "palette-new-tab", label: "Open in a new tab" },
  { id: "palette-copy-link", label: "Copy link" },
  { id: "palette-move", label: "Move" },
  { id: "escape", label: "Close" },
] as const;

/**
 * The palette's footer: its keys as Kbd caps for the reader's platform, each
 * with what it does, wrapping on a narrow screen.
 *
 * Spec: specs/design-system/ledger-shell.feature
 */
export function CommandBarFooter({ isMac }: CommandBarFooterProps) {
  return (
    <HStack
      borderTopWidth="1px"
      borderColor="var(--color-border-2)"
      paddingX="var(--space-4)"
      paddingY="var(--space-2)"
      columnGap="var(--space-4)"
      rowGap="var(--space-1)"
      flexWrap="wrap"
      fontSize="var(--text-12)"
      color="var(--color-fg-2)"
    >
      {FOOTER_HINTS.map(({ id, label }) => {
        const shortcut = shortcutById(id);
        const chords = [...shortcut.keys, ...(shortcut.alternatives ?? [])];
        return (
          <HStack key={id} gap="var(--space-1)">
            {chords.map((chord) => (
              <Kbd key={chord}>{formatChordLabel({ chord, isMac })}</Kbd>
            ))}
            <Text as="span">{label}</Text>
          </HStack>
        );
      })}
    </HStack>
  );
}
